import viewcartApi from '@/service/modules/viewcartApi';
import { createSlice } from '@reduxjs/toolkit';
import { AppDispatch } from '../store';

interface CartListState {
  data: {
    count: number;
  };
  error: string | null;
}

const initialState: CartListState = {
  data: {
    count: 0
  },
  error: null
};

const dealCartData = (shopCartData: { data: { count: number } }) => {
  const { count } = shopCartData.data
  return {
    count
  }
}

const cartListSlice = createSlice({
  name: 'cartList',
  initialState,
  reducers: {
    loadingSuccess: (state, action) => {
      // 保存数据到状态
      state.data = action.payload;
    },
    loadingFailure: (state, action) => {
      state.error = action.payload.message;
    },
    updateCartList: (state, action) => {
      state.data = dealCartData(action.payload);
    }
  }
})

export const {
  loadingSuccess,
  loadingFailure,
  updateCartList
} = cartListSlice.actions;

export const getCartList = () => async (dispatch: AppDispatch) => {
  try {
    const res = await viewcartApi.getList();
    dispatch(loadingSuccess(dealCartData(res)));
  } catch (error: any) {
    dispatch(loadingFailure(error));
  }
};



export default cartListSlice.reducer;